import gql from 'graphql-tag'

export const customerDeliveryExceptionsQuery = gql`
  query ($shipToIds: [String!]) {
    customerDeliveryExceptions(shipToIds: $shipToIds) {
      shipTo
      shipToId
      hasExceptions
      popupSeen
      deliveryExceptions {
        transportation
        deliveryExceptions {
          originalDate
          scheduledDate
          orderBy
          originalHours
          scheduledHour
          shipTo
          typeOfChange
          acn_userguid
          standardorder
          unfilteredorder
          tankorder
          posmInventoryDay
          truckorder
          shipToId
          orderByDefaultHasPassed
        }
      }
    }
  }
`
